import { createFileRoute } from "@tanstack/react-router";
import MasiniDealeriVerificati from "@/pages/MasiniDealeriVerificati";
import { routeHead } from "@/lib/seo/route-head";
import { loadVerifiedDealers } from "@/lib/seo/verified-dealers-seo";

export const Route = createFileRoute("/masini-dealeri-verificati/")({
  head: () => routeHead("/masini-dealeri-verificati/"),
  loader: () => loadVerifiedDealers("RO"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <MasiniDealeriVerificati />
  );
}
